import {
  canCurrentUserEditField,
  getCurrentUserId,
} from "@/utils/fieldEditableByUser";

export default {
  inject: {
    formContext: { default: null },
  },
  computed: {
    canCurrentUserEditThisField() {
      return canCurrentUserEditField(
        this.field,
        this.resolveRecordForEditableBy(),
        getCurrentUserId()
      );
    },
    effectiveFieldMode() {
      if (this.isFilter) return this.mode;
      if (this.mode === "edit" && !this.canCurrentUserEditThisField) {
        return "view";
      }
      return this.mode;
    },
  },
  methods: {
    resolveRecordForEditableBy() {
      if (this.item && typeof this.item === "object") return this.item;
      if (this.recordItem && typeof this.recordItem === "object") {
        return this.recordItem;
      }
      if (this.parentItem && typeof this.parentItem === "object") {
        return this.parentItem;
      }
      const ctx = this.formContext;
      if (!ctx) return null;
      if (typeof ctx.getState === "function") return ctx.getState();
      if (ctx.formData && typeof ctx.formData === "object") return ctx.formData;
      return null;
    },
  },
};
